import logo from "../../../assets/logo.svg";

import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.brand}>
          <div className={styles["brand-logo"]}>
            <img src={logo} alt="" />
            <span className={styles.textBold}>StartAppify</span>
          </div>
          <div className={styles.footerLinks}>
            <span className={styles.textLight}>
              Powered By NucleApp Pvt Ltd
            </span>
            <div className={styles.textMedium}>Quick Links</div>
            <ul className={styles.quickLinks}>
              <li
                onClick={() => handleNavigation("/terms-of-service")}
                className={styles.link}
              >
                Terms of Services
              </li>
              <li
                onClick={() => handleNavigation("/privacy-policy")}
                className={styles.link}
              >
                Privacy Policy
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.address}>
          <span className={styles.title}>Address</span>
          <pre>
            {
              "NucleApp Software Private Limited \nAwfis Space Solutions, \nKondapur \nHyderabad, Telangana, \nIndia -500084."
            }
          </pre>
          <a href="mailto:support@nucleapp.com">support@nucleapp.com</a>
        </div>

        <div className={styles.social}>
          <p>Connect with us</p>
          <div className={styles.socialIcons}>
            <FaFacebook
              onClick={() =>
                handleNavigation(
                  "https://www.facebook.com/profile.php?id=61573569298178"
                )
              }
            />
            <FaInstagram
              onClick={() =>
                handleNavigation("https://www.instagram.com/startappify/")
              }
            />
            <FaYoutube
              onClick={() =>
                handleNavigation("https://www.youtube.com/@StartAppify")
              }
            />
            {/* <FaLinkedin
              onClick={() =>
                handleNavigation(
                  "https://www.linkedin.com/showcase/startappify/ "
                )
              }
            /> */}
            <FaXTwitter
              onClick={() => handleNavigation("https://x.com/StartAppify")}
            />
          </div>
          <div className={styles.footerLinksMobile}>
            <span className={styles.textLight}>Powered By NucleApp</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
